<template>
     <el-dialog :title="!modelForm.id ? '新增企业' : '修改额度'" width="500px" :visible.sync="modalVisible" append-to-body
          destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false" @close="$emit('close')">
          <div class="warm-tips" v-if="!modelForm.id">
               <i class="el-icon-info"></i>
               <div>
                    <span>1.请完成企业信息设置，设置后企业方可用手机号验证身份订房。</span>
                    <span>2.支持信用额度消费和月结方式结算。</span>
                    <span>3.支持预存并优先扣除预存金额，灵活结算</span>
               </div>
          </div>
          <el-form :model="modelForm" ref="modelForm" label-width="110px" size="small" :rules="modelFormRules">
               <div class="legend-title">基本信息</div>

               <el-form-item label="联系人" prop="contact">
                    <el-input v-model="modelForm.contact" placeholder="请输入联系人" clearable style="width: 300px"></el-input>
               </el-form-item>
               <el-form-item label="手机号" prop="phone">
                    <el-input v-model="modelForm.phone" placeholder="请输入手机号" :disabled="!!modelForm.id" clearable style="width: 300px"></el-input>
               </el-form-item>
               <el-form-item label="企业名称" prop="name">
                    <el-input v-model="modelForm.name" placeholder="请输入企业名称" clearable style="width: 300px"></el-input>
               </el-form-item>
               <div class="legend-title">结算设置</div>

               <el-form-item label="结算类型" prop="type">
                    <el-radio-group v-model="modelForm.type" @change="handleChangeType">
                         <el-radio :label="0">信用额度</el-radio>
                         <el-radio :label="1">月结</el-radio>
                    </el-radio-group>
               </el-form-item>

               <el-form-item prop="totalCredit" v-if="modelForm.type == 0">
                    <template slot="label">
                         <span>信用额度</span>
                         <el-tooltip class="item" effect="dark" content="授权信用消费额度，可先消费后对账，未完成结算的企业将无法继续预订" placement="top-start">
                              <i style="color: #C8C9CC;font-size: 18px;" class="el-icon-question"></i>
                         </el-tooltip>
                    </template>
                    <el-input v-model="modelForm.totalCredit" placeholder="请输入信用额度" clearable style="width: 300px"></el-input>
               </el-form-item>

               <el-form-item prop="settlementTime" v-if="modelForm.type == 1">
                    <template slot="label">
                         <span>结算日</span>
                         <el-tooltip class="item" effect="dark" content="固定每月日期结算上一周期账单，未完成结算的企业将无法继续预订" placement="top-start">
                              <i style="color: #C8C9CC;font-size: 18px;" class="el-icon-question"></i>
                         </el-tooltip>
                    </template>
                    <el-select v-model="modelForm.settlementTime" placeholder="请选择结算日期" style="width: 300px">
                         <el-option :label="'每月' + item + '日'" :value="item + ''" v-for="(item,key) in 30" :key="item"></el-option>
                    </el-select>
               </el-form-item>

               <el-form-item prop="discount">
                    <template slot="label">
                         <span>企业折扣</span>
                         <el-tooltip class="item" effect="dark" content="设置折扣，企业订房可享受一定折扣优惠" placement="top-start">
                              <i style="color: #C8C9CC;font-size: 18px;" class="el-icon-question"></i>
                         </el-tooltip>
                    </template>
                    <el-input v-model="modelForm.discount" placeholder="可输入1-9.9之间折扣，如7.7为77折(选填)" clearable style="width: 300px"></el-input>
               </el-form-item>
               <el-form-item label="预存金额(元)" prop="amount" v-if="!modelForm.id">
                    <el-input v-model="modelForm.amount" placeholder="可输入企业预存金额" clearable style="width: 300px"></el-input>
               </el-form-item>

               <el-form-item label="预存凭证" prop="expectImage" v-if="!modelForm.id">
                    <el-upload class="image-uploader image-uploader1" action="/room/upload/img" :headers="headers" name="mulFile"
                         :data="{ key: 'head' }" :show-file-list="false"
                         :on-success="handleAvatarSuccess"
                         :before-upload="beforeAvatarUpload">
                         <img v-if="modelForm.expectImage" :src="modelForm.expectImage" class="avatar">
                         <div v-else class="image-uploader-icon">
                              <i class="el-icon-plus"></i>
                              <span>上传图片</span>
                         </div>
                         <div slot="tip" class="el-upload__tip"
                              style="width: 250px;line-height: 20px;font-size: 11px;color: #999999;">支持jpg .jpeg
                              .png格式，大小不超过5M，最多上传1张</div>
                    </el-upload>
               </el-form-item>
          </el-form>

          <div slot="footer">
               <el-button type="text" @click="modalVisible = false">取消</el-button>
               <el-button type="primary" size="small" :loading="submitLoading"
                    @click="handleSubmit('modelForm')">确认</el-button>
          </div>
     </el-dialog>
</template>

<script>

export default {
     computed: {
        headers() {
            return {
                "Authorization": localStorage.getItem('Token'),
            }
        },
    },

    props: {
          isShow: {
               type: Boolean,
               default: false
          },
          id: {
               type: String,
               default: null
          }
    },

     data() {
          const validateContact = (rule, value, callback) => {
               if (!value || value.length > 10) {
                    callback(new Error('联系人不能为空且长度最多10位'));
               } else if (/[^a-zA-Z0-9\_\u4e00-\u9fa5]/.test(value)) {
                    callback(new Error('联系人不能输入非法字段'));
               } else {
                    callback();
               }
          };
          const validatePhone = (rule, value, callback) => {
            let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!reg.test(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        }
          const validateName = (rule, value, callback) => {
               if (value.length > 30) {
                    callback(new Error('企业名称长度最多30位'));
               } else if (/[^a-zA-Z0-9\_\u4e00-\u9fa5]/.test(value)) {
                    callback(new Error('企业名称不能输入非法字段'));
               } else {
                    callback();
               }
          };
          const validateCredit = (rule, value, callback) => {
               if (!value || value <=0  ||  !/^\d+(\.\d{1,2})?$/.test(value)) {
                    callback(new Error("信用额度只能大于0且只能保留两位小数"));
               } else {
                    callback();
               }
          };

          const validateDiscount = (rule, value, callback) => {
               if (value && !/^\d+(\.\d{1})?$/.test(value)) {
                    callback(new Error("折扣只能保留一位小数"));
               } else  if (value && (value > 9.9 || value < 1) ) {
                    callback(new Error("折扣只能在1~9.9之间"));
               } else {
                    callback();
               }
          };

          const validatePrice = (rule, value, callback) => {
               if (value && !/^\d+(\.\d{1,2})?$/.test(value)) {
                    callback(new Error("预存金额不能为空且只能保留两位小数"));
               } else {
                    callback();
               }
          };
          return {
              
               modelForm: {
                    name: "",
                    contact: '',
                    phone: '',
                    type: "",
                    totalCredit: "",
                    discount: '',
                    amount: "",
                    expectImage: "",
                    settlementTime: ""
               },
               modalVisible: false,
               modelFormRules: {
                    name: [{validator: validateName, trigger: "change" }],
                    contact: [{ required: true, validator: validateContact, trigger: "change" }],
                    phone: [{ required: true, validator: validatePhone, trigger: "change" }],
                    totalCredit: [{ required: true, validator: validateCredit, trigger: "change" }],
                    discount: [{ validator: validateDiscount, trigger: "change" }],
                    amount: [{ validator: validatePrice, trigger: "change" }],
                    settlementTime: [{ required: true, message: "请选择结算日", trigger: "change" }],
                    type: [{ required: true, message: "请选择结算类型", trigger: "change" }],
               },
               submitLoading: false,
          }
     },
     watch: {
          isShow(newVal) {
               this.modalVisible = newVal;
               if(!!newVal) {
                    this.modelForm = {
                         name: "",
                         contact: '',
                         phone: '',
                         type: 0,
                         totalCredit: "",
                         discount: '',
                         amount: "",
                         expectImage: "",
                         settlementTime: ""

                    };

                    if(this.id) {
                         this.getEnterpriseDetail();
                    }
               }
          }
     },

     methods: {
          handleChangeType() {
               // this.modelForm.totalCredit = "";
               // this.modelForm.settlementTime = "";
               this.$refs.modelForm.clearValidate(['totalCredit','settlementTime'])
          },
          handleAvatarSuccess(res) {
               if(res.code == 200) {
                    this.modelForm.expectImage = res.data;
               } else {
                    this.$message.error(res.msg);
               }
          },
          beforeAvatarUpload(file) {
               const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/jpe') || (file.type === 'image/png');
               const isLt2M = file.size / 1024 / 1024 < 5;

               if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/JPEG/PNG 格式!');
               }
               if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 5MB!');
               }
               return isJPG && isLt2M;
          },


          handleSubmit(fromName) {
               this.$refs[fromName].validate(valid => {
                    if (valid) {
                         this.submitLoading = true;
                         if (!this.modelForm.id) {
                              this.handleAddApi();
                         } else {
                              this.handleEditApi();
                         }
                    }
               })
          },

          handleAddApi() {
               this.postRequest("/enterCredit/addCredit", this.modelForm)
               .then(res => {
                    this.submitLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                         this.$message.success("操作成功");
                         this.$emit('confirm');
                    }
               }).catch(() => {
                    this.submitLoading = false;
               })
          },

          handleEditApi() {
               this.putRequest("/enterCredit/editCredit", this.modelForm)
               .then(res => {
                    this.submitLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                         this.$message.success("操作成功");
                         this.$emit('confirm');
                    }
               }).catch(() => {
                    this.submitLoading = false;
               })
          },

          getEnterpriseDetail() {
               this.getRequest(`/enterCredit/getDetail?id=${this.id}`)
               .then(res => {
                    let data = res.data;
                    if (data.code == 200) {
                         this.modelForm = data.data;
                    }
               })

          },
     },
}
</script>

<style lang="less">@import "./index.less";</style>